export default "__VITE_ASSET__80db9301__"